// extracted by mini-css-extract-plugin
module.exports = {"datetime":"GBsp","item":"GBat","time":"GBjz"};